module.exports = __webpack_public_path__ + "static/img/14000511.003d846e.png";